import { CityInfo } from '../contract/map'
import gis from './gis.json'

// // >9 城市视图出现大icon
// // 7～9 路线视图，无三方点
// // <=7 全国视图  有三方背景点和全国资源
// export const DEFAULT_COUNTRY_ZOOM_LEVEL = 7
// export const DEFAULT_CITY_ZOOM_LEVEL = 9
// export const DEFAULT_DISTRICT_ZOOM_LEVEL = 10

export const CITY_MAP: { [index: string]: CityInfo } = gis
